// Compute a uniform career-card width for a section. Cards only widen when
// a single TOKEN (word) is longer than what fits in the default 100px card;
// multi-word names like "Graphic Designer" stay at 100 and wrap naturally
// across two lines. Single long words like "Cosmetologist" or
// "Otorhinolaryngologist" bump the section to the next tier so they don't
// truncate. All cards in the section render at the same width (parity).
export function uniformCardWidth(names: (string | undefined | null)[]): number {
  const longestToken = names.reduce((max, n) => {
    const tokens = (n || '').trim().split(/\s+/)
    const local = tokens.reduce((m, t) => Math.max(m, t.length), 0)
    return Math.max(max, local)
  }, 0)
  if (longestToken <= 10) return 100
  if (longestToken <= 14) return 120
  if (longestToken <= 18) return 140
  return 160
}
